<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12"><h1 style="text-align: center">Projects of the DaLiCo Summer School 2022</h1></v-col>

     <v-col cols="12">
        <v-card  class="mx-auto">
          <v-card-text >
            <p>
              During the last DaLiCo Summer School in July 2022 the focus was on digital literacy skills and competencies researchers should have when working with research data. Data projects were developed in international teams with PhD, Master and Bachelor students from all partner countries. The results of those data projects are being presented here.
            </p>
          </v-card-text >
        </v-card>
      </v-col>

      <v-col cols="6" v-for="project in projects[2022]" :key="project.id">
        <v-card class="mx-auto">
          <v-img class="white--text align-end" height="200px" :src="project.image">
            <v-card-title>{{project.title}}</v-card-title>
          </v-img>

          <v-card-subtitle class="pb-0">{{project.team}}</v-card-subtitle>

          <v-card-text class="text--primary">
            <div>{{project.description}}</div>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn color="orange" text @click="$router.push({name: project.id})">Open</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import projects from '../data/projects.json'

export default {
  name: 'ProjectOverview2022',
  computed: {
    projects() {
      return projects
    }
  }
}
</script>
